import { render, staticRenderFns } from "./PostImageMod.vue?vue&type=template&id=c8e4ffb0"
import script from "./PostImageMod.vue?vue&type=script&lang=js"
export * from "./PostImageMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports